import React, { useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PubSub from "services/PubSub/";
import TagManagerService from "services/TagManager";
import style from './style.scss'; //NOSONAR

let timeMouseEnter = null;

const ItemCategory = (props) => {
    const categories = props.categories;
    const menu = useRef(null);
    const button = useRef(null);
    const {getContainerRef} = props;

    const [category, setCategory] = useState(false);
    const [menuPositioned, setMenuPositioned] = useState(false);
    const [marginLeft, setMarginLeft] = useState(0);
    const [posDetail, setPosDetail] = useState(0);

    const applyMenuPosition = () => {
        const menuContainer = getContainerRef();
        
        if(menu && menu.current && menuContainer){
            const $menu = menu.current;
            const $button = button.current;
            let widthHalf = ($menu.offsetWidth / 2);
            const maxPos = (menuContainer.offsetWidth - $menu.offsetWidth);
            let pos = $button.offsetLeft + ($button.offsetWidth / 2) - widthHalf;
            let posDetailAux = $button.offsetLeft + ($button.offsetWidth / 2) - 7;

            if(pos < 0){
                pos = 0;
            }

            if(pos + $menu.offsetWidth > menuContainer.offsetWidth){
                pos = maxPos - 32;
            }

            if(pos !== marginLeft || posDetailAux !== posDetail){
                setMarginLeft(pos + 16);
                setPosDetail(posDetailAux);
            }

            if(!menuPositioned){
                setMenuPositioned(true);
            }
        }
    };

    useEffect(() => {
        if(typeof window !== 'undefined'){
            window.addEventListener('resize', applyMenuPosition);
        }

        return function cleanup(){
            window.removeEventListener('resize', applyMenuPosition);
        }
    }, []);

    const closeMenu = (url) => {

        if (typeof (url) === 'string') {
            const title_path = url.replace('/', '').replace('_', ' ');
            const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
            TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Superior');
        }else if(props.title === 'Supermercado') {
            TagManagerService.menu('Home', 'Home', 'Menú Superior');
        }
        
        setCategory(false);
    };

    useEffect(() => {
        applyMenuPosition();
    }, [category]);

    const setCategoryVisible = (isVisible) => {

        PubSub.dispatch('toggle_menu', { state: false });
        PubSub.dispatch('toggle_minicart', { state: false });

        clearTimeout(timeMouseEnter);

        if(isVisible){
            timeMouseEnter  = setTimeout(() => {
                setCategory(true);
            }, 100);
        } else {
            setCategory(false);
        }
    };

    const noChildrenCat = [];

    return (
        <div className="new-header-supermarket-button" onMouseEnter={() => setCategoryVisible(true)} onMouseLeave={()=>setCategoryVisible(false)} ref={button}>
            <div className={"new-header-dropdown-overlay " + (category ? " active" : "")} onMouseEnter={()=> setCategoryVisible(false)}></div>
            <div className="new-header-supermarket-dropdown-container">
                <Link to={props.url || ''} className="new-header-supermarket-title" onClick={()=>closeMenu(props.url)}><h3>{props.title}</h3></Link>
                {(category) && <div className={"new-header-supermarket-wrap " + (menuPositioned ? "active" : "")}>
                    <div className='new-header-navbar-arrow-up' style={{'left': posDetail}}></div>
                    <div className='new-header-supermarket-wrap-event' style={{'left': marginLeft}} onMouseLeave={()=>setCategoryVisible(false)}>
                        <ul className="new-header-supermarket-dropdown" ref={menu}>
                            {(categories) && categories.map((item) => {
                                if(item.items.length){
                                    return (
                                        <li className="new-header-supermarket-dropdown-items" key={item.title}>
                                            <Link to={item.url} className="new-header-supermarket-dropdown-item-name" onClick={()=>closeMenu(item.url)}>{item.title}</Link>
                                            {item.items && item.items.length && item.items.slice(0, 4).map((child) => {
                                                return(
                                                    <Link to={child.url} key={child.title} className="new-header-supermarket-dropdown-item-childrens" onClick={()=>closeMenu(child.url)}>{child.title}</Link>)}
                                            )}
                                            <Link to={item.url} className="new-header-supermarket-dropdown-btn-view-more" onClick={()=>closeMenu(item.url)}>Ver todos</Link>
                                        </li>)
                                }else{
                                    noChildrenCat.push(item);
                                }
                            })}
                            {noChildrenCat.length &&
                            <li className="new-header-supermarket-dropdown-items">
                                {(noChildrenCat && (noChildrenCat.length !== categories.length)) && <Link to={props.url || ''} className="new-header-supermarket-dropdown-item-name">Otros</Link>}
                                {noChildrenCat.slice(0, 6).map((child) => {
                                    return(<Link to={child.url} key={child.title} className="new-header-supermarket-dropdown-item-childrens" onClick={()=>closeMenu(child.url)}>{child.title}</Link>)
                                })}
                                {(noChildrenCat && (noChildrenCat.length === categories.length)) && <Link to={props.url} className="new-header-supermarket-dropdown-btn-view-more" onClick={()=>closeMenu(props.url)}>Ver todos</Link>}
                            </li>
                            }
                        </ul>
                    </div>
                </div>}
            </div>
        </div>
        
    )
}

ItemCategory.propTypes = {
    title: PropTypes.string,
    categories: PropTypes.array,
    getContainerRef: PropTypes.func,
    url: PropTypes.string
};

export default ItemCategory;
